import Svg, { Path } from 'react-native-svg';

type Props = {
  size?: number;
};

const IconHelpTooltip = ({ size = 24 }: Props) => (
  <Svg width={size} height={size} viewBox="0 0 24 24">
    <Path
      d="M12.5,2C6.704,2 2,6.704 2,12.5S6.704,23 12.5,23 23,18.296 23,12.5 18.296,2 12.5,2zM12.5,21.95c-5.21,0 -9.45,-4.24 -9.45,-9.45 0,-5.21 4.24,-9.45 9.45,-9.45 5.21,0 9.45,4.24 9.45,9.45 0,5.21 -4.24,9.45 -9.45,9.45z"
      fill="#DDDDDD"
    />
    <Path
      d="M11.503,15.753h1.75v1.75h-1.75zM12.912,7.038A3.502,3.502 0,0 0,9.036 9.48a0.793,0.793 0,0 0,0.76 1.023h0.176c0.359,0 0.647,-0.253 0.77,-0.586a1.752,1.752 0,0 1,2.012 -1.12c0.832,0.175 1.444,0.989 1.374,1.838 -0.087,1.172 -1.417,1.426 -2.144,2.52 0,0.008 -0.008,0.008 -0.008,0.017 -0.01,0.018 -0.018,0.026 -0.027,0.044 -0.078,0.131 -0.157,0.28 -0.218,0.437 -0.01,0.027 -0.027,0.044 -0.035,0.07 -0.01,0.018 -0.01,0.035 -0.018,0.062a3.253,3.253 0,0 0,-0.175 1.093h1.75c0,-0.367 0.096,-0.673 0.245,-0.936 0.018,-0.026 0.026,-0.052 0.044,-0.079 0.07,-0.122 0.157,-0.236 0.245,-0.34 0.009,-0.01 0.017,-0.027 0.026,-0.036 0.088,-0.105 0.184,-0.201 0.289,-0.297 0.84,-0.797 1.977,-1.444 1.741,-3.115 -0.21,-1.523 -1.409,-2.81 -2.931,-3.037z"
      fill="#6093FC"
    />
  </Svg>
);

export default IconHelpTooltip;
